import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";

const VariablesHeading = () => {
	const { t } = useTranslation();

	return (
		<div className="list-group-heading variables__heading">
			<CardColumn width="lg">
				{t("main.variables.headings.name")}
			</CardColumn>
			<CardColumn width="lg">
				{t("main.variables.headings.type")}
			</CardColumn>
			<CardColumn width="xl">
				{t("main.variables.headings.value")}
			</CardColumn>
		</div>
	);
};

export default VariablesHeading;
